import {
  GAME_ID,
  REDUX_ACTIONS,
} from '../../data/wordCityConstants';

const initialState = {
  levels: [],
  // onboarding's own questions, kept so the city can rebuild its tower in a later session
  onboardingItems: [],
  currentLevelId: null,
};

// need toppers to appear for every level except 1st for questions number 1 and 3
const isTopperItem = (levelId, questionIndex) => (levelId > 0 && (questionIndex === 1 || questionIndex === 3));

const wordCityCurriculumReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.LOAD_CURRICULUM: {
      // a curriculum without an onboarding block simply contributes no tower to the city
      const { curriculum: { levels, onboarding = { standardItems: [] } }, levelsToppers } = action.payload;
      let topperCounter = 0;

      return {
        ...initialState,
        onboardingItems: onboarding.standardItems || [],
        levels: levels.map(level => ({
          ...level,
          standardItems: level.standardItems.map((question, questionIndex) => ({
            ...question,
            topperId: isTopperItem(level.id, questionIndex) ? levelsToppers[topperCounter++] : null,
          })),
          masteredLevelThreshold: Math.round(level.standardItems.length * 0.8),
        })),
      };
    }
    case REDUX_ACTIONS.SELECT_LEVEL: {
      return {
        ...state,
        currentLevelId: action.payload,
      };
    }
    default:
      return state;
  }
};

export default wordCityCurriculumReducer;
